import React, { Component } from 'react';
import { BarLoader } from 'react-spinners';
import EventTeaser from './EventTeaser';
import EventPaginator from './EventPaginator';
import './Events.css'

class Events extends Component
{
    constructor(props) {
        super(props)
        this.eventRefs = {};
    }

    componentDidUpdate(prevProps) {
        if (this.props.events.from != null && Array.isArray(this.props.events.data) && this.props.events.data[this.props.events.from]) {
            const targetId = this.props.events.data[this.props.events.from].id; //geht immer aufs 2. Element, da from immer bei 1 losgeht
            const targetRef = this.eventRefs[targetId];

            if (targetRef.props && targetRef.props.shouldUpdate === true) {
                const internalRefs = targetRef.refs;
                const refKeys = Object.keys(internalRefs);

                if (refKeys.length > 0) {
                    const buttonEl = internalRefs[refKeys[0]];

                    if (buttonEl.focus) {
                        buttonEl.focus();
                    }
                }
            }
        }
    }

    render() {
        if (!this.props.events.data) {
            return <div className={'row'}>
                <div className={'col-md-12'}>
                    <BarLoader/>
                </div>
            </div>
        }

        if (this.props.events.total === 0) {
            return <div className={'row'}>
                <div className={'col-md-12'}>
                    <div className={'row'}>
                        <div className={'col-sm-8'}>
                            <strong>Keine Veranstaltungen gefunden</strong>
                        </div>
                    </div>
                </div>
            </div>
        }

        return (
            <div className={'row'}>
                <div className={'col-md-12'}>
                    <div className={'row'}>
                        <div className={'col-sm-8'}>
                        <h2 className={'subline'}>
                            <strong>{this.props.events.total}</strong> Veranstaltungen gefunden
                        </h2>
                        </div>
                    </div>
                    <hr />
                    <ul aria-label="Liste von Veranstaltungen" className={'aktuelle-termine'}>
                        {this.props.events.data.map(event => (
                            <EventTeaser
                                key={event.id}
                                event={event}
                                shouldUpdate={
                                    (this.props.events.data && this.props.events.from !== 1 && this.props.events.data[this.props.events.from])
                                        ? this.props.events.data[this.props.events.from].id === event.id 
                                        : false
                                }
                                ref={el => (this.eventRefs[event.id] = el)} 
                                fulltext={this.props.fulltext}
                            />
                        ))}
                    </ul>
                    <EventPaginator
                        eventData={this.props.events}
                        appendEventsNextPage={this.props.appendEventsNextPage}
                        eventsAdding={this.props.eventsAdding}
                    />
                </div>
            </div>
        );
    }
}

export default Events


// WEBPACK FOOTER //
// ./src/components/Events.js